import { Box, Typography } from '@mui/material'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
import CustomOption from '../components/Inputs/CustomOption'
import CustomSlider from '../components/Inputs/CustomSlider'

const Transporting = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light">
        <span className="general-text">Task Name -</span> Transporting Paint &
        Equipment
      </Typography>
      <br />
      <br />
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="Environmental - incidient/spills"
        name="environmental_incident"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>

            <CustomOption
              label="Unsecured hazardous material containers in vehicles -"
              name="unsecured_material_containers"
              warning=" Is it a risk at this site?"
              component={
                <Box>
                  <CustomSlider
                    label="Inherent Risks - Unsecured hazardous material container in vehicles"
                    name="inherent_risks_unsecured_container"
                  />
                  <br />
                  <Typography color="primary" className="general-text">
                    How will the hazards and risks be controlled?
                  </Typography>
                  <br />
                  <Typography className="general-text">
                    All lids securely fastened and materials securely fastened
                    in vehicles
                  </Typography>
                  <br />
                  <CustomSlider
                    label="Residual Risk"
                    name="residual_risk_unsecured_container"
                  />
                </Box>
              }
            />
            <CustomOption
              label="Waste to Ground - "
              name="waste_to_ground"
              warning=" Is it a risk at this site?"
              component={
                <Box>
                  <Typography color="primary" className="general-text">
                    How hazards will be controlled?
                  </Typography>
                  <br />
                  <Typography className="general-text">
                    Prevent contamination to sewers, drains and waterways and
                    zero waste to ground.
                  </Typography>

                  <CustomSlider
                    label="Inherent Risk Rating"
                    name="inherent_risk_rating_waste"
                  />
                  <br />
                  <CustomSlider
                    label="Residual Risk Rating"
                    name="residual_risk_rating_waste"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Environmental - incidient/spills"
      />
      <CustomCheckbox
        label="Flying Objects"
        name="flying_objects"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>

            <CustomOption
              label="Flying Objects - Struck by flying object -"
              name="flying_objects"
              warning=" Is it a risk at this site?"
              component={
                <Box>
                  <Typography color="primary" className="general-text">
                    How will the hazards and risks be controlled?
                  </Typography>

                  <Typography className="general-text">
                    Fixed barrier between driver cabin and storage area of the
                    vehicle
                  </Typography>
                  <br />
                  <CustomSlider
                    label="Inherent Risk Rating"
                    name="inherent_risk_rating_flying"
                  />
                  <br />
                  <CustomSlider
                    label="Residual Risk Rating"
                    name="residual_risk_rating_flying"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Environmental - incidient/spills"
      />
      <CustomCheckbox
        label="Securing Ladders/planks"
        name="securing_ladders"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>
            <CustomOption
              label="Horizontal overhang of ladders, planks etc"
              name="horizontal_overhand"
              warning="Is it a risk at this site?"
              component={
                <Box>
                  <Typography color="primary" className="general-text">
                    How will the hazards and risks be controlled?
                  </Typography>
                  <br />
                  <Typography className="general-text">
                    Minimize horizontal overhang of ladders and planks. Tie a
                    red flag (at least 300mm x 300mm) on the end of any ladder /
                    plank that extends beyond the rear of the vehicle
                  </Typography>
                  <CustomSlider
                    label="Inherent Risk Rating"
                    name="inherent_risk_rating_horizontal_overhand"
                  />
                  <br />
                  <CustomSlider
                    label="Residual Risk Rating"
                    name="residual_risk_rating_horizontal_overhand"
                  />
                  <br />
                </Box>
              }
            />
            <CustomOption
              label="Unsecured ladders and planks - "
              name="unsecured_ladders"
              warning="Is it a risk at this site?"
              component={
                <Box>
                  <Typography color="primary" className="general-text">
                    How hazards will be controlled?
                  </Typography>
                  <br />
                  <Typography className="general-text">
                    Install securing points for ladders, planks to minimal
                    movement and vibration
                  </Typography>
                  <CustomSlider
                    label="Inherent Risk Rating"
                    name="inherent_risk_rating_unsecured_ladders"
                  />
                  <br />
                  <CustomSlider
                    label="Residual Risk Rating"
                    name="residual_risk_rating_unsecured_ladders"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Securing Ladders/planks"
      />
    </Box>
  )
}

export default Transporting
